import React, {useEffect} from "react";
import Styles from "./Rules.module.scss"
import {RulesPropsType} from "./types";
import {Header, Title} from "../../components";
import {useLocation} from "react-router-dom";

export const Rules: React.FC<RulesPropsType> = ({title}) => {
	const location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return (
		<>
			<Header title={title} />
			<main>
				<section className="container">
					<Title>{title}</Title>
					<div className={Styles.textWrapper}>
						<div className={Styles.title}>
						  Правила и публичная оферта клуба Tennis.ru №001T
						</div>
						<div className={Styles.text}>
							Данный документ является официальным предложением (публичной офертой) ООО «Теннис.рф» и содержит все существенные условия предоставления услуг.
						</div>
						<div className={Styles.text}>
							Физическое лицо принимает условия данной оферты и соглашается с условиями, представленными на официальном сайте Клуба и в мобильном приложении, путем совершения оплаты.
						</div>
						<div className={Styles.text}>
							В соответствии с пунктом 2 статьи 437 Гражданского Кодекса Российской Федерации в случае принятия изложенных ниже условий и оплаты услуг, физическое лицо производит акцепт этой оферты и, в соответствии с пунктом 3 статьи 438 ГК РФ, акцепт оферты равносилен заключению договора на условиях, изложенных в оферте.
						</div>
						<div className={Styles.text}>
							Оферта является официальным документом и публикуется на официальном сайте tennis.ru, его поддомене arenda.tennis.ru, а также на официальном сайте клуба www.теннис.рф и в мобильном приложении "tennis.ru"
						</div>
						<div className={Styles.text}>
							Совершение действий, указанных в данной оферте, направленных на ее принятие означает принятие лицом всех условий оферты в полном объеме, без исключений и оговорок.
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									1.
								</div>
								Общие положения
							</div>
							<div className={Styles.text}>
								<span>1.1.</span> Допуск в клуб разрешается только при наличии действующей клубной карты (абонемента) и зарегистрированном у администраторов клуба посещении. 
							</div>
							<div className={Styles.text}>
								<span>1.2.</span> Часы работы Клуба: ежедневно, кроме 1-го января, с 8:00 до 23:00 часов в будние дни и с 9:00 до 23:00 часов в выходные и праздничные дни. Допуск в Клуб прекращается, если до окончания работы Клуба осталось менее 60 минут. Тренировочные зоны заканчивают свою работу за 20 минут до закрытия Клуба.
							</div>
							<div className={Styles.text}>
								<span>1.3.</span> Член Клуба, обязан покинуть Клуб до наступления обозначенного времени, в случае задержки, член клуба обязан уплатить штраф согласно прейскуранту. В случае несоблюдения режима работы и неоднократного нарушения, Клуб в праве расторгнуть договор в одностороннем порядке без возвращения средств. 
							</div>
							<div className={Styles.text}>
								<span>1.4.</span> Клуб имеет право изменять часы работы Клуба, и/или порядок и/или часы пользования отдельными зонами/студиями/залами и т.д. Информация об указанных изменениях размещается на информационных стендах Клуба и/или иных носителях и/или на рецепции, и/или на сайте Клуба: TENNIS.RU. Часы работы Клуба, размещаются в Клубе на рецепции, информационных стендах, и/или иным предусмотренным Договором способом доводятся до Членов Клуба.
							</div>
							<div className={Styles.text}>
								<span>1.5.</span> Клуб вправе приостановить свою работу на срок не более 4 дней в году для проведения мероприятий по улучшению качества обслуживания Членов Клуба, а также на необходимый срок для проведения ремонтных и профилактических работ, без предоставления компенсации. О приостановлении работы Клуб обязуется заранее проинформировать Членов Клуба. Клуб оставляет за собой право в течение года полностью закрывать зону бассейна для проведения ремонтных и профилактических работ с оборудованием, чашей и помещениями бассейна не более 30 дней в году. Дни такого закрытия не компенсируются.
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									2.
								</div>
								Определения и термины
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>2.1.</span> Теннисный клуб (Клуб) – Теннисный клуб «Tennis.ru», расположенный по адресу: г. Москва, п. Сосенское, д. Летово, ул.Летовская Малая д.8
								</div>
								<div className={Styles.text}>
									<span>2.2.</span> Договор – настоящие Правила и Прейскурант, заключаемый между Заказчиком и Исполнителем путем акцепта Заказчиком предложений Исполнителя в установленном порядке.
								</div>
								<div className={Styles.text}>
									<span>2.3.</span> Услуга(и) – оказываемые Исполнителем услуги, предусмотренные Договором.
								</div>
								<div className={Styles.text}>
									<span>2.4.</span> Клиент – для целей настоящих Правил, лицо заключившее Договор в установленном порядке. Договор в отношении несовершеннолетних детей заключают их законные представители (родители, опекуны и т.д).
								</div>
								<div className={Styles.text}>
									<span>2.5.</span> Посетитель – физическое лицо, находящееся на территории Теннисного клуба.
								</div>
								<div className={Styles.text}>
									<span>2.6.</span> Сотрудник – любое лицо, участвующее в оказании услуг со стороны Исполнителя.
								</div>
								<div className={Styles.text}>
									<span>2.7.</span> Абонемент – документ, подтверждающий право физических лиц получить услуги, в соответствии с Прейскурантом, в количестве, оплаченном Заказчиком.
								</div>
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									3.
								</div>
								Режим работы клуба
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>3.1.</span> Будни: с 07:00 до 23:00
								</div>
								<div className={Styles.text}>
									<span>3.2.</span> Выходные: с 9:00 до 23:00
								</div>
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									4.
								</div>
								Правила поведения на территории клуба
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>4.1.</span> Клиенты и Посетители Теннисного клуба обязаны выполнять требования и предписания Администрации.
								</div>
								<div className={Styles.text}>
									<span>4.2.</span> Клиенты и Посетители спортивного комплекса обязаны соблюдать чистоту и порядок на территории, кортах и помещениях Теннисного клуба.
								</div>
								<div className={Styles.text}>
									<span>4.3.</span> Клиенты и Посетители спортивного комплекса обязаны соблюдать нормы приличия, не оскорблять честь и достоинства Посетителей и Сотрудников Клуба.
								</div>
								<div className={Styles.text}>
									<span>4.4.</span> Клиенты и Посетители обязаны бережно относиться к имуществу Теннисного клуба.
								</div>
								<div className={Styles.text}>
									<span>4.5.</span> Клиенты и Посетители спортивного комплекса обязаны соблюдать правила дорожного движения на территории клубной парковки и не создавать помех своим автотранспортом для других посетителей клуба.
								</div>
								<div className={Styles.text}>
									<span>4.6.</span> Клиенты и Посетители Клуба обязаны возвратить полученное во временное пользование имущество спортивного комплекса.
								</div>
								<div className={Styles.text}>
									<span>4.7.</span> Посетителям и Клиентам Теннисного клуба запрещается:
								</div>
								<div className={Styles.text}>
									<div className={Styles.text}>
										<span>4.7.1.</span> Появляться на территории теннисного клуба в состоянии алкогольного или наркотического опьянения;
									</div>
									<div className={Styles.text}>
										<span>4.7.2.</span> Распивать спиртные напитки или употреблять наркотические вещества и препараты;
									</div>
									<div className={Styles.text}>
										<span>4.7.3.</span> Употреблять нецензурные выражения;
									</div>
									<div className={Styles.text}>
										<span>4.7.4.</span> Проводить на корты лиц, не обутых в чистую специализированную теннисную обувь;
									</div>
									<div className={Styles.text}>
										<span>4.7.5.</span> Жевать и выбрасывать на кортах жевательную резинку.
									</div>
								</div>
								<div className={Styles.text}>
									<span>4.8.</span> При нахождении на кортах спортивного комплекса Клиент обязан соблюдать следующие правила:
								</div>
								<div className={Styles.text}>
									<div className={Styles.text}>
										<span>4.8.1.</span> Использовать для занятий корт строго под номером, указанным в абонементе и/или в расписании и не мешать при проходе на свой корт другим занимающимся;
									</div>
									<div className={Styles.text}>
										<span>4.8.2.</span> Выходить на корт только в чистой специализированной теннисной спортивной обуви с подошвой “NON-MARKINGOUTSOLE”;
									</div>
									<div className={Styles.text}>
										<span>4.8.3.</span> Не проносить на корт соки и напитки с красителями;
									</div>
									<div className={Styles.text}>
										<span>4.8.4.</span> Не производить действий, способных нанести повреждения оборудованию и покрытию кортов, а также иных помещений Клуба. В случае порчи имущества, инвентаря и оборудования Клиент обязуется возместить ущерб в полном объеме;
									</div>
									<div className={Styles.text}>
										<span>4.8.5.</span> Не оставлять на кортах мелкий мусор (обрывки обмотки, струн и др.),
									</div>
									<div className={Styles.text}>
										<span>4.8.6.</span> Не кричать и не издавать шумы и звуки, отвлекающие игроков на корте;
									</div>
									<div className={Styles.text}>
										<span>4.8.7.</span> Не проносить на корты звуковоспроизводящую технику.
									</div>
									<div className={Styles.text}>
										<span>4.8.8.</span> Освобождать корт сразу по окончании арендованного времени или групповой тренировки. За задержку на корте от 10 минут и до 30 минут взымается плата за аренду 30 минут корта на данный час. От 30 мин и более взымается арендная плата за полный час по расценке за данное время;
									</div>
									<div className={Styles.text}>
										<span>4.8.9.</span> Мячи на корте должны быть собраны строго до окончания арендуемого времени.
									</div>
									<div className={Styles.text}>
										<span>4.8.10.</span> При занятиях на улице в солнечную и жаркую погоду ученик/ученица должен быть намазан кремом от загара и иметь при себе:
									</div>
									<ul className={Styles.text}>
										<li>Головной убор</li>
										<li>Большую бутылку воды</li>
										<li>Сменную футболку</li>
										<li>Небольшое полотенце</li>
										<li>Для вечерней тренировки - средство от комаров</li>
									</ul>
								</div>
								<div className={Styles.text}>
									<span>4.9.</span> Для проведения тренировочного процесса использовать только оборудованные для этого помещения. Запрещено проводить занятия в коридорах, проходах между кортами.
								</div>
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									5.
								</div>
								Порядок оплаты и предоставления услуг
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>5.1.</span> Теннисным клубом предоставляются услуги по обеспечению возможности занятий теннисом:
								</div>
								<div className={Styles.text}>
									<span>5.1.1.</span> Аренда теннисных кортов и инвентаря;
								</div>
								<div className={Styles.text}>
									<span>5.1.2.</span> Занятия теннисом в группах различной возрастной категории (Групповые тренировки);
								</div>
								<div className={Styles.text}>
									<span>5.1.3.</span> Индивидуальные занятия теннисом (Персональные тренировки);
								</div>
								<div className={Styles.text}>
									<span>5.1.4.</span> Групповые специализированные занятия общефизической подготовкой (ОФП).
								</div>
								<div className={Styles.text}>
									<span>5.2.</span> Оплата Услуг производится в безналичном порядке или наличными в кассу Клуба.
								</div>
								<div className={Styles.text}>
									<span>5.2.1.</span> Аренда корта осуществляется только через официальное мобильное приложение Tennis.ru или официальный сайт arenda.tennis.ru, корт считается забронированным только после осуществления оплаты. Возврат и обмен, и перенос предоплаченного времени невозможен, совершив оплату через приложение или сайт вы подтверждаете ваше согласие с условиями оферты.
								</div>
								<div className={Styles.text}>
									<span>5.2.2.</span> Индивидуальные тренировки оплачиваются в кассе клуба перед началом тренировки.
								</div>
								<div className={Styles.text}>
									<span>5.2.3.</span> Занятия в группе оплачиваются в 100%-м размере за весь период оказания услуги. Период оказания услуги определяется календарным месяцем. Оплату необходимо произвести в период с 25-го числа предыдущего месяца и не позднее 1-го числа текущего месяца предоставления услуги. Оплата за групповые занятия по факту занятий не производится.
								</div>
								<div className={Styles.text}>
									<span>5.2.4.</span> Групповые тренировки имеет право проводить только Школа тенниса Теннис.ру. На корте во время тренировки с тренером, не состоящим в штате Школы теннис.ру, допускается нахождение максимум 2 человек.
								</div>
								<div className={Styles.text}>
									<span>5.3.</span> Клиенты, не оплатившие Услугу (и) в полном объеме и в установленные сроки не допускаются до занятий.
								</div>
								<div className={Styles.text}>
									<span>5.4.</span> Для допуска к занятиям Клиенту необходимо предъявить тренеру чек об оплате. Чек необходимо получить перед началом каждой тренировки (групповой и/или индивидуальной) на стойке ресепшен.
								</div>
								<div className={Styles.text}>
									<span>5.5.</span> При необходимости может быть составлен и выдан график предоставления услуг(и) с более подробными характеристиками порядка оказания услуг(и).
								</div>
								<div className={Styles.text}>
									<span>5.6.</span> Порядок бронирования и оплаты Аренды кортов подробно описан в Пункте 6 данных Правил.
								</div>
								<div className={Styles.text}>
									<span>5.7.</span> В заключении Договора (в предоставлении услуг) может быть отказано в случае отсутствия у Теннисного клуба возможности оказать услугу(и):
								</div>
								<ul>	
									<li>Отсутствие свободных кортов;</li>
									<li>Отсутствие мест в группах и т.п.</li>
								</ul>
								<div className={Styles.text}>
									<span>5.8.</span> Занятия теннисом не желательно для Клиентов с медицинскими противопоказаниями. Администрация клуба настоятельно рекомендует Клиенту пройти медицинский осмотр у врача до начала занятий. Для получения услуг, связанных с детскими занятиями, Клиент обязан до начала проведения занятий предоставить справку от лечащего врача об отсутствии противопоказаний для проведения занятий, в том числе коллективных занятий, с указанием имеющихся у Ребенка хронических заболеваний и диагнозов, требующих особого внимания со стороны сотрудников Теннисного клуба.
								</div>
								<div className={Styles.text}>
									<span>5.9.</span> Теннисный клуб не несет ответственность за состояние здоровья и возможный травматизм Клиентов, занимающихся детей и Посетителей в следующих случаях:
								</div>
								<div className={Styles.text}>
									<span>5.9.1.</span> При нарушении Правил посещения Клуба;
								</div>
								<div className={Styles.text}>
									<span>5.9.2.</span> Нарушения рекомендаций инструктора Клуба;
								</div>
								<div className={Styles.text}>
									<span>5.9.3.</span> За травмы, полученные вне территории Клуба;
								</div>
								<div className={Styles.text}>
									<span>5.9.4.</span> За травмы, полученные от противоправных действий третьих лиц;
								</div>
								<div className={Styles.text}>
									<span>5.9.5.</span> За травмы, полученные по вине Клиента и/или Посетителя на территории Клуба;
								</div>
								<div className={Styles.text}>
									<span>5.9.6.</span> Если Администрация Клуба не была незамедлительно поставлена в известность о получении травмы на территории Клуба, вне зависимости от обстоятельств получения и характера травмы.
								</div>
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									6.
								</div>
								Порядок бронирования и оплаты аренды кортов
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>6.1.</span> Аренда кортов производится с учетом расписания работы кортов, проведения турниров и соревнований, производства ремонтно-профилактических работ.
								</div>
								<div className={Styles.text}>
									<span>6.2.</span> Приоритет по Аренде кортов в будни с 15:00 до 21:00 и в выходные с 9:00 до 14:00 имеют групповые и индивидуальные занятия учеников Школы тенниса Tennis.ru.
								</div>
								<div className={Styles.text}>
									<span>6.3.</span> Аренда кортов предоставляется:
								</div>
								<ul>
									<li>При наличии 100%-й предоплаты аренды корта на бронируемый период, бронирование и оплата производится через официальное мобильное приложение Tennis.ru или официальный сайт arenda.tennis.ru.</li>
									<li>На любое кол-во времени кратное одному часу.</li>
									<li>При наличии свободных кортов в этот период.</li>
								</ul>
								<div className={Styles.text}>
									<span>6.4.</span> Максимальный период бронирования кортов составляет не более одного календарного месяца.
								</div>
								<div className={Styles.text}>
									<span>6.5.</span> Стоимость аренды кортов указана в календаре в мобильном приложении и на сайте и в прейскуранте на стойке администрации клуба.
								</div>
								<div className={Styles.text}>
									<span>6.6.</span> В выходные и праздничные дни аренда кортов может предоставляться по цене выходного дня.
								</div>
								<div className={Styles.text}>
									<span>6.7.</span> Оплата аренды корта для проведения индивидуальных занятий (персональных тренировок) производится до начала занятий.
								</div>
								<div className={Styles.text}>
									<span>6.8.</span> Игровой час составляет 55 минут.
								</div>
								<div className={Styles.text}>
									<span>6.9.</span> Клиент обязан освободить корт сразу по истечении арендованного времени. За задержку на корте от 15 до 30 минут взимается плата за аренду 30 минут корта на данный час. От 30 минут и более взимается арендная плата за полный час по расценке за данное время.
								</div>
								<div className={Styles.text}>
									<span>6.10.</span> Клиент не имеет права выходить на корт ранее своего забронированного времени, разминку можно совершить в специально отведенных местах между 16-м и 5-м кортами.
								</div>
								<div className={Styles.text}>
									<span>6.11.</span> Контрольное время использования кортов устанавливается по часам спортивного комплекса Tennis.ru.
								</div>
								<div className={Styles.text}>
									<span>6.12.</span> При пользовании теннисными кортами Клиенты несут ответственность за себя, своих детей и Гостей.
								</div>
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									7.
								</div>
								Групповые занятия
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>7.1.</span> Групповые занятия проводятся в соответствии с программами и расписанием Клуба, в которых определено время проведения таких занятий.
								</div>
								<div className={Styles.text}>
									<span>7.2.</span> Группы формируются по возрастным категориям и уровню подготовки клиента.
								</div>
								<div className={Styles.text}>
									<span>7.3.</span> Кол-во учеников в группе составляет от 6 до 12 человек.
								</div>
								<div className={Styles.text}>
									<span>7.4.</span> Руководство Клуба самостоятельно разрабатывает и утверждает программы и расписание занятий.
								</div>
								<div className={Styles.text}>
									<span>7.5.</span> Расписание занятий находится у администратора Школы Тенниса.
								</div>
								<div className={Styles.text}>
									<span>7.6.</span> Руководство Клуба самостоятельно определяет Тренера для групповых занятий, исходя из фактического количества тренеров в смене их загруженности и иных объективных факторов.
								</div>
								<div className={Styles.text}>
									<span>7.7.</span> Руководство Клуба вправе вносить изменения в расписание групповых занятий, в том числе производить замену указанного в расписании тренера.
								</div>
								<div className={Styles.text}>
									<span>7.8.</span> Руководство Клуба, выбирает формы, средства и методы проведения занятий.
								</div>
								<div className={Styles.text}>
									<span>7.9.</span> В случае опоздания на групповые занятия более, чем на 15 минут, без предварительного согласования с тренером, тренер имеет право не допустить Клиента на занятия. В этом случае услуга считается оказанной. Опоздание на занятия не влекут их продления.
								</div>
								<div className={Styles.text}>
									<span>7.10.</span> При непосещении Клиентом Клуба по независящим от Клуба причинам в период действия Договора деньги не возвращаются, при этом Клиенту не предоставляется возможность переноса времени занятий.
								</div>
								<div className={Styles.text}>
									<span>7.11.</span> Каждый месячный абонемент оплачивается в размере 100% стоимости абонемента не зависимо от кол-ва занятий, пропущенных в предыдущих периодах.
								</div>
								<div className={Styles.text}>
									<span>7.12.</span> Пропущенные групповые занятия компенсации не подлежат.
								</div>
								<div className={Styles.text}>
									<span>7.13.</span> При проведении турниров, соревнований Администрация Клуба имеет право производить изменения в расписании групповых занятий. Администрация обязуется заблаговременно уведомить Клиента об изменении в расписании.
								</div>
								<div className={Styles.text}>
									<span>7.14.</span> При получении услуг(и) Клиенты имеют право пользоваться раздевалками, душем, другой инфраструктурой Клуба.
								</div>
								<div className={Styles.text}>
									<span>7.15.</span> При получении услуг по занятиям детей Клиент обязан:
								</div>
								<div className={Styles.text}>		
									<div className={Styles.text}>
										<span>7.15.1.</span> Приводить Ребенка в Теннисный клуб здоровым;
									</div>
									<div className={Styles.text}>
										<span>7.15.2.</span> Предоставить до начала проведения занятий справку от лечащего врача об отсутствии противопоказаний для проведения Занятий, в том числе коллективных Занятий, с указанием имеющихся у Ребенка хронических заболеваний и диагнозов, требующих особого внимания со стороны тренеров Физкультурно-оздоровительного комплекса;
									</div>
									<div className={Styles.text}>
										<span>7.15.3.</span> Приводить Ребенка чистым и опрятным, в спортивной или удобной для занятий одежде и сменной обуви;
									</div>
									<div className={Styles.text}>
										<span>7.15.4.</span> Соблюдать настоящие Правила и обеспечить их соблюдение Ребенком;
									</div>
									<div className={Styles.text}>
										<span>7.15.5.</span> Приводить и забирать Ребенка лично у тренеров Клуба не доверять Ребенка лицам, не достигшим 18 лет, лицам, находящимся в нетрезвом состоянии. В случае доверия Ребенка другому лицу представить письменное согласие на доверие другому лицу привести или забрать Ребенка с указанием фамилии, имени, отчества, паспортных данных доверенного представителя;
									</div>
									<div className={Styles.text}>
										<span>7.15.6.</span> Обеспечить сохранность имущества Клуба и нести полную материальную ответственность за предоставленное имущество. В случае причинения ущерба имуществу Клуба по вине Ребенка, при утрате имущества, предоставленного в связи с предоставлением услуг, Клиент обязан возместить причиненный ущерб.
									</div>
									<div className={Styles.text}>
										<span>7.15.7.</span> Уважать честь и достоинство Сотрудников Клуба и обеспечить их уважение Ребенком;
									</div>
									<div className={Styles.text}>
										<span>7.15.8.</span> Выполнять требования инструкторов и тренеров Клуба по предмету Договора и обеспечить их выполнение Ребенком, не чинить препятствий и не вмешиваться в тренировочный процесс;
									</div>
									<div className={Styles.text}>
										<span>7.15.9.</span> Обеспечить ребенка на время тренировки бутылкой питьевой воды (0,5 литра) для снижения риска обезвоживания.
									</div>
								</div>
								<div className={Styles.text}>
									<span>7.16.</span> Клиент вправе присутствовать на Занятиях с Ребенком в том случае, когда это требуется для адаптации Ребенка к коллективным занятиям, после предварительного согласования с тренером Клуба
								</div>
								<div className={Styles.text}>
									<span>7.17.</span> Тренер Клуба несет ответственность за детей в возрасте до 14 (Четырнадцати) лет только во время занятий и в пределах теннисного корта, в остальное время ответственность несут родители, иные законные представители или уполномоченным ими лица.
								</div>
								<div className={Styles.text}>
									<span>7.18.</span> Дети в возрасте до 14 (Четырнадцати) лет могут находиться на территории Клуба без сопровождения родителей, иных законных представителей (или уполномоченных ими лиц) только во время занятий с Тренером на теннисном корте.
								</div>
								<div className={Styles.text}>
									<span>7.19.</span> В случае явного неадекватного поведения со стороны ребенка (агрессия, истерические состояния, намеренная порча имущества) Теннисный клуб вправе требовать от родителей, иных законных представителей (или уполномоченных ими лиц) личного присутствия при посещении ребенком Клуба либо расторгнуть Договор в одностороннем порядке.
								</div>
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									8.
								</div>
								Индивидуальные затянятия (Персональные тренировки)
							</div>
							<div className={Styles.text}>
								
									<div className={Styles.text}>
										<span>8.1.</span> Индивидуальные тренировки проводятся Тренером клуба на заранее забронированном и оплаченном корте в заранее согласованное время.
									</div>
									<div className={Styles.text}>
										<span>8.2.</span> Оплату тренировки и аренды корта клиент производит в 100%-ном размере заблаговременно до начала занятий.
									</div>
									<div className={Styles.text}>
										<span>8.3.</span> В случае отмены занятий клиент обязан предупредить тренера о своем отсутствии через администратора Клуба по телефонам 8(903)556-44-44 за 24 часа до начала занятий. В ином случае услуга считается оказанной, деньги не возвращаются.
									</div>
									<div className={Styles.text}>
										<span>8.4.</span> Срок действия абонемента на 10 индивидуальных тренировок - 60 дней с момента оплаты.
									</div>
								
							</div>
						</div>
						<div>
							<div className={Styles.title}>
								<div className={`${Styles.title_number}`}>
									9.
								</div>
								Прочие положения
							</div>
							<div className={Styles.text}>
								<div className={Styles.text}>
									<span>9.1.</span> Обращаем Ваше внимание, что администрация клуба и персонал не несут ответственность за ценные вещи и деньги Клиентов и посетителей клуба. Администрация не несёт ответственность за вещи, оставленные в раздевалках и спортивных сооружениях, кортах, а также за вещи, оставленные в шкафах. Администрация также не несет ответственности за утерянные или оставленные без присмотра вещи. Администрация и работники клуба не несут ответственности за сохранность автотранспорта посетителей и клиентов теннисного клуба.
								</div>
								<div className={Styles.text}>
									<span>9.2.</span> Фото и видео съемка на территории Теннисный клуба "Tennis.ru" разрешена. Фотографии детей посещающих занятия клуба, могут быть размещены в помещениях клуба, сайте www.tennis.ru, мобильном приложении "tennis.ru", наших альбомах в соц. сетях, материалах СМИ, и рекламных материалах.
								</div>
								<div className={Styles.text}>
									<span>9.3.</span> Теннисный клуб «Tennis.ru» не несет ответственности за качество услуг по консультированию и обучению теннису, оказанных лицами, не являющимися сотрудниками теннисной школы клуба.
								</div>
							</div>
						</div>
					</div>
				</section>
			</main>
		</>
	)
}
